module.exports = __webpack_public_path__ + "static/media/signs.656cc01b.svg";